import { Localization } from "../../../common/localizable-component";
import { VideoplayerLocalization } from "./videoplayer-types";

export const VIDEOPLAYER_LOCALIZATION: Localization<VideoplayerLocalization> = {
  en: {
    play: "Play",
    pause: "Pause",
    continue: "Continue",
    replay: "Replay",
    toggleFullscreen: "Enter/Leave Fullscreen Mode",
    togglePlayPause: "Play/Pause",
    toggleMute: "Mute/Unmute",
    toggleCaptions: "Caption On/Off",
    posterAltDefault: "video poster",
    posterTitleDefault: "video poster",
    percentPlayed: "{0} played",
    unableToPlay: "Unfortunately, we are unable to play the video.",
    videoTagNotSupported: "Your browser does not support the <video> tag.",
    videoButtonDescription:
      "Use space and enter keys to toggle video playback. Use cursor left and right keys to backward or forward playback.",
    videoButtonRoledescription: "Video Player"
  },
  de: {
    play: "Abspielen",
    pause: "Pausieren",
    continue: "Fortsetzen",
    replay: "Nochmal abspielen",
    toggleFullscreen: "Vollbild an/aus",
    togglePlayPause: "Abspielen/Pausieren",
    toggleMute: "Ton an/aus",
    toggleCaptions: "Untertitel an/aus",
    posterAltDefault: "Video Poster",
    posterTitleDefault: "Video Poster",
    percentPlayed: "{0} abgespielt",
    unableToPlay: "Leider können wir das Video nicht abspielen.",
    videoTagNotSupported: "Ihr Browser unterstützt das <video> tag leider nicht.",
    videoButtonDescription:
      "Mit Leertaste und Entertaste zwischen Abspielen und Pause wechseln. Pfeiltaste links und Pfeiltaste rechts zum Vor- bzw. Zurückspulen nutzen.",
    videoButtonRoledescription: "Videowiedergabe"
  },
  sv: {
    play: "Spela",
    pause: "Pausa",
    continue: "Fortsätt",
    replay: "Spela igen",
    toggleFullscreen: "Öppna/Lämna helskärmsläge",
    togglePlayPause: "Spela/Pausa",
    toggleMute: "Ljud av/Ljud på",
    toggleCaptions: "tbd",
    posterAltDefault: "bakgrundsbild video",
    posterTitleDefault: "bakgrundsbild video",
    percentPlayed: "{0} spelade",
    unableToPlay: "Tyvärr kan vi inte spela upp videon.",
    videoTagNotSupported: "Din webbläsare stöder inte <video>.",
    videoButtonDescription:
      "Använd mellanslag och enter-tangenterna för att växla videouppspelning. Använd vänster och höger piltangenter för att spola bakåt eller framåt.",
    videoButtonRoledescription: "Videospelare"
  },
  nl: {
    play: "Speel",
    pause: "Pauzeer",
    continue: "Ga door",
    replay: "Replay",
    toggleFullscreen: "Volledig scherm modus openen/verlaten",
    togglePlayPause: "Afspelen/Pauze",
    toggleMute: "Mute/Unmute",
    toggleCaptions: "tbd",
    posterAltDefault: "video poster",
    posterTitleDefault: "video poster",
    percentPlayed: "{0} gespeeld",
    unableToPlay: "Helaas kunnen we de video niet afspelen.",
    videoTagNotSupported: "Uw browser ondersteunt de <video> tag niet.",
    videoButtonDescription:
      "Gebruik de spatiebalk en de enter-toets om de videoweergave te schakelen. Gebruik de linker- en rechterpijltoetsen om terug of vooruit te spoelen.",
    videoButtonRoledescription: "Videospeler"
  },
  it: {
    play: "Riproduci",
    pause: "Interrompi",
    continue: "Continua",
    replay: "Ripeti",
    toggleFullscreen: "Entra/Esci dalla modalità a schermo intero",
    togglePlayPause: "Riproduci/Interrompi",
    toggleMute: "Silenzia/Attiva audio",
    toggleCaptions: "tbd",
    posterAltDefault: "avviso video",
    posterTitleDefault: "avviso video",
    percentPlayed: "{0} riprodotto",
    unableToPlay: "Sfortunatamente, non siamo in grado di riprodurre il video.",
    videoTagNotSupported: "Il tuo browser non supporta il tag di <video>.",
    videoButtonDescription:
      "Usa i tasti spazio e invio per attivare/disattivare la riproduzione del video. Usa i tasti freccia sinistra e destra per riavvolgere o avanzare.",
    videoButtonRoledescription: "Lettore video"
  },
  hu: {
    play: "Lejátszás",
    pause: "Szünet",
    continue: "Folytatás",
    replay: "Visszajátszás",
    toggleFullscreen: "Teljes képernyőre váltás / Kilépés a teljes képernyős módból",
    togglePlayPause: "Lejátszás/Szüneteltetés",
    toggleMute: "Némítás/Némítás feloldása",
    toggleCaptions: "tbd",
    posterAltDefault: "Videó közzététele",
    posterTitleDefault: "Videó közzététele",
    percentPlayed: "{0} lejátszva",
    unableToPlay: "Sajnos a videó lejátszása nem lehetséges.",
    videoTagNotSupported: "Sajnos a használt böngésző nem támogatja a beágyazott videó használatát.",
    videoButtonDescription:
      "Használja a szóköz és az enter billentyűket a videólejátszás váltásához. Használja a bal és jobb nyílbillentyűket a visszatekeréshez vagy az előretekeréshez.",
    videoButtonRoledescription: "Videolejátszó"
  },
  da: {
    play: "Afspil",
    pause: "Pause",
    continue: "Fortsæt",
    replay: "Genafspil",
    toggleFullscreen: "Fuld skærm/Afslut fuld skærm",
    togglePlayPause: "Afspil/Pause",
    toggleMute: "Lyd fra/Lyd til",
    toggleCaptions: "tbd",
    posterAltDefault: "video plakat",
    posterTitleDefault: "video plakat",
    percentPlayed: "{0} afspillet",
    unableToPlay: "Vi kan desværre ikke afspille videoen.",
    videoTagNotSupported: "Browseren understøtter ikke <video>",
    videoButtonDescription:
      "Brug mellemrumstasten og enter-tasten til at skifte videoafspilning. Brug venstre og højre piletaster til at spole tilbage eller frem.",
    videoButtonRoledescription: "Videoafspiller"
  },
  fr: {
    play: "Jouer",
    pause: "Pause",
    continue: "Continuer",
    replay: "Replay",
    toggleFullscreen: "Entrer/sortir du mode plein écran",
    togglePlayPause: "Lecture/Pause",
    toggleMute: "Mute/Unmute",
    toggleCaptions: "tbd",
    posterAltDefault: "poster vidéo",
    posterTitleDefault: "poster vidéo",
    percentPlayed: "{0} jouée",
    unableToPlay: "Malheureusement, nous ne sommes pas en mesure de lire la vidéo.",
    videoTagNotSupported: "Votre navigateur ne prend pas en charge la balise <video>.",
    videoButtonDescription:
      "Utilisez les touches espace et entrée pour basculer la lecture vidéo. Utilisez les touches fléchées gauche et droite pour reculer ou avancer.",
    videoButtonRoledescription: "Lecteur vidéo"
  },
  es: {
    play: "Play",
    pause: "Pausar",
    continue: "Continuar",
    replay: "Repetir",
    toggleFullscreen: "Entrar/Salir del modo de pantalla completa",
    togglePlayPause: "Play/Pausa",
    toggleMute: "Silenciar/activar",
    toggleCaptions: "tbd",
    posterAltDefault: "póster de vídeo",
    posterTitleDefault: "póster de vídeo",
    percentPlayed: "jugados",
    unableToPlay: "Lamentablemente, no podemos reproducir el vídeo.",
    videoTagNotSupported: "Su navegador no soporta la etiqueta <video>.",
    videoButtonDescription:
      "Utilice las teclas de espacio y enter para alternar la reproducción de video. Utilice las teclas de flecha izquierda y derecha para retroceder o avanzar.",
    videoButtonRoledescription: "Reproductor de video"
  },
  pl: {
    play: "Odtwórz",
    pause: "Wstrzymaj",
    continue: "Kontynuuj",
    replay: "Powtórz",
    toggleFullscreen: "Wejście/wyjście z trybu pełnoekranowego",
    togglePlayPause: "Odtwórz/Wstrzymaj",
    toggleMute: "Wyciszenie/wyłączenie wyciszenia",
    toggleCaptions: "tbd",
    posterAltDefault: "plakat wideo",
    posterTitleDefault: "plakat wideo",
    percentPlayed: "{0} grano",
    unableToPlay: "Niestety, nie jesteśmy w stanie odtworzyć tego filmu.",
    videoTagNotSupported: "Twoja przeglądarka nie obsługuje znacznika <video>.",
    videoButtonDescription:
      "Użyj klawiszy spacji i enter, aby przełączać odtwarzanie wideo. Użyj klawiszy strzałek w lewo i w prawo, aby przewijać do tyłu lub do przodu.",
    videoButtonRoledescription: "Odtwarzacz wideo"
  },
  ro: {
    play: "Joacă",
    pause: "Pauză",
    continue: "Continuă",
    replay: "Redare",
    toggleFullscreen: "Intrați/ieșiți din modul ecran complet",
    togglePlayPause: "Redare/Pauză",
    toggleMute: "Mute/Unmute",
    toggleCaptions: "tbd",
    posterAltDefault: "poster video",
    posterTitleDefault: "poster video",
    percentPlayed: "{0} redat",
    unableToPlay: "Din păcate, nu putem reda videoclipul.",
    videoTagNotSupported: "Browserul dvs. nu acceptă tag-ul <video>.",
    videoButtonDescription:
      "Utilizați tastele spațiu și enter pentru a comuta redarea videoclipului. Utilizați tastele săgeată stânga și dreapta pentru a derula înapoi sau înainte.",
    videoButtonRoledescription: "Player video"
  },
  hr: {
    play: "Igraj",
    pause: "Pavza",
    continue: "Nadaljuj",
    replay: "Ponovitev",
    toggleFullscreen: "Vstopite/zapustite celozaslonski način",
    togglePlayPause: "Predvajaj/Premor",
    toggleMute: "Izklopi/Vklopi zvok",
    toggleCaptions: "tbd",
    posterAltDefault: "video plakat",
    posterTitleDefault: "video plakat",
    percentPlayed: "{0} igral",
    unableToPlay: "Žal videoposnetka ne moremo predvajati.",
    videoTagNotSupported: "Vaš brskalnik ne podpira oznake <video>.",
    videoButtonDescription:
      "Koristite tipke razmak i enter za prebacivanje reprodukcije videozapisa. Koristite tipke sa strelicama lijevo i desno za premotavanje unatrag ili unaprijed.",
    videoButtonRoledescription: "Video player"
  },
  cs: {
    play: "Přehrát",
    pause: "Pozastavit",
    continue: "Pokračovat",
    replay: "Přehrát",
    toggleFullscreen: "Vstup/výstup z celoobrazovkového režimu",
    togglePlayPause: "Přehrát/pozastavit",
    toggleMute: "Ztlumit/vypnout zvuk",
    toggleCaptions: "tbd",
    posterAltDefault: "video plakát",
    posterTitleDefault: "video plakát",
    percentPlayed: "{0} přehrává se",
    unableToPlay: "Video se nám bohužel nedaří přehrát.",
    videoTagNotSupported: "Váš prohlížeč nepodporuje značku <video>",
    videoButtonDescription:
      "Pomocí klávesy mezerník a enter přepínejte přehrávání videa. Pomocí kláves se šipkami doleva a doprava přetáčejte zpět nebo dopředu.",
    videoButtonRoledescription: "Přehrávač videa"
  },
  sl: {
    play: "Igraj",
    pause: "Prekinitev",
    continue: "Nadaljuj",
    replay: "Ponovitev",
    toggleFullscreen: "Vstop/izstop iz celozaslonskega načina",
    togglePlayPause: "Predvajanje/počasno predvajanje",
    toggleMute: "Izklop/izklop zvoka",
    toggleCaptions: "tbd",
    posterAltDefault: "video plakat",
    posterTitleDefault: "video plakat",
    percentPlayed: "{0} predvajano",
    unableToPlay: "Žal ne moremo predvajati videoposnetka.",
    videoTagNotSupported: "Vaš brskalnik ne podpira oznake <video>.",
    videoButtonDescription:
      "Uporabite preslednico in tipki enter za preklapljanje predvajanja videa. Uporabite tipki s puščicama levo in desno za previjanje nazaj ali naprej.",
    videoButtonRoledescription: "Predvajalnik videa"
  }
};
